import { StyledTr } from "./styles";
import { StyledTd } from "../styles";
import React, { useState } from "react";

export const AccountRow = ({
  AccountId,
  CompanyName,
  ClassifierThreshold,
  count,
  idp_doc_count,
  SubsidiaryAccountInfo,
  selectedSubsidiary,
  setSelectedSubsidiary,
  files,
  activeDocuments,
  selectedAccount,
  setSelectedAccount,
  setShowRemoveSelectedFilesPopup,
  setShowPendingDocumentPopup,
  isESub,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  console.log("active documents: ", activeDocuments);

  const activeDocs = activeDocuments.map((doc) => ({
    accountId: doc.account_id,
    subsidiaryId: doc.subsidiary_id,
  }));

  const handleRowClick = (AccountId) => {
    setSelectedSubsidiary({
      AccountId: "",
      SubsidiaryID: "",
      SubsidiaryName: "",
      SubsidiaryAddress: "",
      ClassifierThreshold: "",
    });

    if (files.length !== 0) {
      setShowRemoveSelectedFilesPopup(true);
      return;
    }


    if (!isESub) {
      for (const doc of activeDocs) {
        const subIdsForAccount = activeDocs
          .filter((d) => d.accountId === AccountId)
          .map((d) => d.subsidiaryId);

        if (subIdsForAccount.includes("")) {
          setShowPendingDocumentPopup(true);
        }
      }
    }

    if (!isESub && SubsidiaryAccountInfo.length > 0) {
      setIsExpanded((prev) => !prev);
    }

    AccountId === selectedAccount.AccountId
      ? setSelectedAccount({
          AccountId: "",
          CompanyName: "",
          ClassifierThreshold: "",
          documentsCount: 0,
        })
      : setSelectedAccount({
          AccountId,
          CompanyName,
          ClassifierThreshold,
          documentsCount: count,
          subsidiaries: SubsidiaryAccountInfo,
        });
  };

  return (
    <>
      <StyledTr
        key={AccountId}
        selected={AccountId === selectedAccount.AccountId}
        onClick={() => handleRowClick(AccountId)}
        style={{ cursor: "pointer", width: "100%" }}
      >
        <StyledTd>{AccountId}</StyledTd>
        <StyledTd>{CompanyName}</StyledTd>
        <StyledTd>
          {!isESub && (() => {
            const subIdsForAccount = activeDocs
              .filter((d) => d.accountId === AccountId)
              .map((d) => d.subsidiaryId);

            if (subIdsForAccount.includes("")) {
              return "Yes";
            }

            return "";
          })()}
        </StyledTd>
        {!isESub && (
          <StyledTd>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <AnimatedChevron
                isExpanded={isExpanded}
                isActive={SubsidiaryAccountInfo.length > 0}
              />
            </div>
          </StyledTd>
        )}
      </StyledTr>
      {isExpanded && !isESub && (
        <style>
          {`
      @keyframes slideDownFadeIn {
        from {
          opacity: 0;
          transform: translateY(-20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `}
        </style>
      )}

      {isExpanded && !isESub && (
        <AnimatedSubsidiaryRows
          SubsidiaryAccountInfo={SubsidiaryAccountInfo}
          setSelectedAccount={setSelectedAccount}
          selectedSubsidiary={selectedSubsidiary}
          setSelectedSubsidiary={setSelectedSubsidiary}
          AccountId={AccountId}
          CompanyName={CompanyName}
          ClassifierThreshold={ClassifierThreshold}
          count={count}
          activeDocuments={activeDocuments}
          setShowPendingDocumentPopup={setShowPendingDocumentPopup}
        />
      )}
    </>
  );
};

const AnimatedSubsidiaryRows = ({
  SubsidiaryAccountInfo,
  setSelectedAccount,
  selectedSubsidiary,
  setSelectedSubsidiary,
  AccountId,
  CompanyName,
  ClassifierThreshold,
  count,
  activeDocuments,
  setShowPendingDocumentPopup,
}) => {
  const activeSubsidiaryIds = activeDocuments.map((doc) => doc.subsidiary_id);

  const handleRowClick = (info) => {
    console.log("Active Documents: ", activeDocuments);

    console.log("Active Sub Ids: ", activeSubsidiaryIds);
    console.log("Info: ", info);

    if (activeSubsidiaryIds.includes(info.SubsidiaryID)) {
      setShowPendingDocumentPopup(true);
    }

    setSelectedAccount({
      AccountId: "",
      CompanyName: "",
      ClassifierThreshold: "",
      documentsCount: "",
      subsidiaries: null,
    });

    info.SubsidiaryID === selectedSubsidiary.SubsidiaryID
      ? setSelectedSubsidiary({
          AccountId: "",
          SubsidiaryID: "",
          SubsidiaryName: "",
          SubsidiaryAddress: "",
          ClassifierThreshold: "",
          parentAccount: null,
        })
      : setSelectedSubsidiary({
          AccountId: AccountId,
          SubsidiaryID: info.SubsidiaryID,
          SubsidiaryName: info.SubsidiaryName,
          SubsidiaryAddress: info.SubsidiaryAddress,
          ClassifierThreshold,
          parentAccount: {
            CompanyName,
            AccountId,
            subsidiaries: SubsidiaryAccountInfo,
          }
        });
  };
  return (
    <>
      {SubsidiaryAccountInfo.map((info, index) => (
        <StyledTr
          key={index}
          onClick={() => handleRowClick(info)}
          style={{
            animation: `slideDownFadeIn 0.5s ease-in-out ${index * 0.01}s both`,
            transformOrigin: "top",
          }}
          selected={info.SubsidiaryID === selectedSubsidiary.SubsidiaryID}
        >
          <StyledTd>
            <span style={{ marginLeft: "10px" }}>{info.SubsidiaryID}</span>
          </StyledTd>
          <StyledTd>
            <span style={{ marginLeft: "10px" }}>{info.SubsidiaryName}</span>
          </StyledTd>
          <StyledTd>
            {activeSubsidiaryIds.includes(info.SubsidiaryID) ? "Yes" : ""}
          </StyledTd>
          <StyledTd></StyledTd>
        </StyledTr>
      ))}
    </>
  );
};

const AnimatedChevron = ({ isExpanded, isActive }) => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 7 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
      transition: "transform 0.5s ease-in-out",
    }}
  >
    <path
      d="M1.60293 0.5C0.748577 0.5 0.287669 1.50212 0.843675 2.15079L2.95517 4.6142C3.35426 5.07981 4.07459 5.07981 4.47368 4.6142L6.58518 2.15079C7.14118 1.50212 6.68027 0.5 5.82592 0.5H1.60293Z"
      fill={isActive ? "#ff6d1d" : "#B9B9C3"}
    />
  </svg>
);
